import React from "react";
import "./Layout.scss";
import { PrimeReactProvider } from "primereact/api";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const value = {
    ripple: true,
  };

  return (
    <PrimeReactProvider value={value}>
      <div className="layout">
        <div className="header-section">
          <Header />
        </div>
        <div className="content">
          <div className="sidebar-section">
            <Sidebar />
          </div>
          <main className="main-section">{children}</main>
        </div>
      </div>
    </PrimeReactProvider>
  );
}
